import { Button } from '@mui/material';
import React from 'react';
import { GoogleLoginResponse, useGoogleLogin } from 'react-google-login';

type Props = {
  successFn: (data: { email: string; givenName: string; familyName: string }) => void;
  clientId: string;
};

export const LoginWithGoogle: React.FC<Props> = ({ successFn, clientId }) => {
  const [hovered, setHovered] = React.useState(false);

  const onSuccess = (response: GoogleLoginResponse) => {
    successFn({ ...response.profileObj } as {
      email: string;
      givenName: string;
      familyName: string;
    });
  };

  const onFailure = (err: any) => {
    console.error(err);
  };

  const { signIn } = useGoogleLogin({
    onSuccess: onSuccess as any,
    onFailure: onFailure as any,
    clientId,
    isSignedIn: true,
    accessType: ''
  });

  return (
    <Button
      fullWidth
      onClick={signIn}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        display: 'flex',
        boxSizing: 'content-box',
        margin: '10px auto 0px',
        padding: '6px 0px',
        borderRadius: ' 4px',
        borderColor: 'transparent',
        backgroundColor: !hovered ? 'white' : '#dbdbdb',
        boxShadow: ' 0px 5px 10px rgba(0, 0, 0, 0.15)',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none'
      }}
    >
      <img
        src="icons/google.svg"
        alt="google login"
        style={{
          height: ' 25px',
          width: '25px',
          marginRight: '10px'
        }}
      ></img>

      <span style={{ color: '#4285f4', fontWeight: 'bolder' }}>Sign up with Google</span>
    </Button>
  );
};
